import $ from "jquery";
import RSVP from "rsvp";
import Utils from "models/helper/Utils";

const AUTH_SURFACE_PAGE_IDS = Object.freeze({
    NEW_SIGNUP: "newSignupPage",
    ONBOARDING_SIGNUP: "onboardingSignupPage",
    NEW_LOGIN: "NewLoginPage"
});

const isAuthSurfacePageId = function(pageId){
    return pageId === AUTH_SURFACE_PAGE_IDS.NEW_SIGNUP ||
        pageId === AUTH_SURFACE_PAGE_IDS.ONBOARDING_SIGNUP ||
        pageId === AUTH_SURFACE_PAGE_IDS.NEW_LOGIN;
};

const getDefaultAfterSignupUrl = function(){
    if(window.location.protocol == "http:" || window.location.protocol == "https:"){
        return location.origin + window.getAppBaseUrl() + "#afterSignup";
    }
    return window.getBaseUrlWithoutEndSlash() + "#afterSignup";
};

const getSignupSuccessRedirectUrl = function(){
    return window.trebble && window.trebble.signupSuccessRedirectUrl ?
        window.trebble.signupSuccessRedirectUrl : null;
};

const syncBrowserUrlForCompletedSignup = function(){
    if(!Utils.getInstance().isBrowserHostedAuthEnvironment() || window.trebble.isEmbededLoginInPage){
        return;
    }

    const redirectUrl = getSignupSuccessRedirectUrl() || getDefaultAfterSignupUrl();

    try{
        const parsedRedirectUrl = new URL(redirectUrl, window.location.href);
        if(parsedRedirectUrl.origin !== window.location.origin){
            return;
        }

        if(window.history && window.history.replaceState){
            window.history.replaceState(null, "", parsedRedirectUrl.toString());
        }else if(parsedRedirectUrl.hash){
            window.location.hash = parsedRedirectUrl.hash;
        }
    }catch(error){
        console.error("Failed preparing post-signup browser URL. Error:" + error);
    }
};

const completeSignupFlow = function(signupResultData, onSignupSuccessfullyCompleted){
    window.trebble.accountSignupHasOccuredInSession = true;

    const ensureSignupCompletionNavigation = function(callbackResult){
        if(
            Utils.getInstance().isBrowserHostedAuthEnvironment() &&
            Utils.getInstance().isTokenValid() &&
            !window.trebble.isEmbededLoginInPage
        ){
            const activePageId = $(".ui-page-active").attr("id");
            const router = window.trebble && window.trebble.trebbleRouter ? window.trebble.trebbleRouter : null;
            if(isAuthSurfacePageId(activePageId) && router && router.showDefaultPageAfterSignup){
                return RSVP.Promise.resolve(router.showDefaultPageAfterSignup(true)).then(function(){
                    return callbackResult;
                });
            }
        }

        return callbackResult;
    };

    if(onSignupSuccessfullyCompleted){
        // Custom callbacks (e.g. forward_url redirects) are expected to own
        // post-signup navigation. Chaining ensureSignupCompletionNavigation
        // here would race against the caller's window.location assignment
        // and overwrite it with showDefaultPageAfterSignup.
        return RSVP.Promise.resolve(onSignupSuccessfullyCompleted(signupResultData));
    }

    const redirectUrl = getSignupSuccessRedirectUrl();
    // Normalize both URLs before comparing — configured defaults may be stored
    // as a relative "#afterSignup" while getDefaultAfterSignupUrl() returns the
    // absolute form. Raw string comparison would miss the match and fall
    // through to window.location assignment instead of router.showDefaultPageAfterSignup.
    let isDefaultAfterSignupRedirect = !redirectUrl || redirectUrl === "#afterSignup";
    if(!isDefaultAfterSignupRedirect && redirectUrl){
        try {
            const resolvedDefaultAfterSignupUrl = new URL(getDefaultAfterSignupUrl(), window.location.href);
            const resolvedRedirectUrl = new URL(redirectUrl, window.location.href);
            isDefaultAfterSignupRedirect =
                resolvedRedirectUrl.origin === resolvedDefaultAfterSignupUrl.origin &&
                resolvedRedirectUrl.pathname === resolvedDefaultAfterSignupUrl.pathname &&
                resolvedRedirectUrl.hash === resolvedDefaultAfterSignupUrl.hash;
        } catch(error){
            isDefaultAfterSignupRedirect = false;
        }
    }

    if(
        Utils.getInstance().isBrowserHostedAuthEnvironment() &&
        Utils.getInstance().isTokenValid() &&
        !window.trebble.isEmbededLoginInPage
    ){
        const router = window.trebble && window.trebble.trebbleRouter ? window.trebble.trebbleRouter : null;
        if(router && isDefaultAfterSignupRedirect){
            if(router.showDefaultPageAfterSignup){
                return RSVP.Promise.resolve(router.showDefaultPageAfterSignup(true)).then(ensureSignupCompletionNavigation);
            }
            if(router.showDefaultPage){
                return RSVP.Promise.resolve(router.showDefaultPage(true)).then(ensureSignupCompletionNavigation);
            }
        }
    }

    if(redirectUrl){
        window.location = redirectUrl;
        return RSVP.Promise.resolve(true);
    }

    if($.mobile && $.mobile.navigate && $.mobile.navigate.history && $.mobile.navigate.history.activeIndex > 0){
        window.history.back();
    }
    return RSVP.Promise.resolve(true);
};

export {
    AUTH_SURFACE_PAGE_IDS,
    isAuthSurfacePageId,
    syncBrowserUrlForCompletedSignup,
    completeSignupFlow
};

export default {
    AUTH_SURFACE_PAGE_IDS: AUTH_SURFACE_PAGE_IDS,
    isAuthSurfacePageId: isAuthSurfacePageId,
    syncBrowserUrlForCompletedSignup: syncBrowserUrlForCompletedSignup,
    completeSignupFlow: completeSignupFlow
};
